module.exports = __webpack_public_path__ + "img/pendencies_icon_grey.af933a9c.svg";